import { FETCH_CURRENCIES_SUCCESS } from '../actions/fetchCurrenciesActions';

export const initialState = [];

const currencies = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === FETCH_CURRENCIES_SUCCESS) {
    const defaultOption = { value: '', label: '---' };

    return [defaultOption, ...payload];
  }

  return state;
};

export default currencies;
